<template>
  <v-dialog v-model="show" width="750">
    <v-card>
      <v-card-title primary-title>
        Submitted reports
      </v-card-title>

      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Reported by</th>
              <th width="50%" class="text-left">Feedback</th>
              <th class="text-left">Reported on</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="report in reports.data" :key="report.id">
              <td>{{ report.user.full_name }}</td>
              <td>{{ report.feedback }}</td>
              <td>{{ report.createdAt }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <div v-if="reports.meta.last_page > 1" class="text-center mt-4">
          <v-pagination
            @input="onPageChanged"
            :value="reports.meta.current_page"
            :length="reports.meta.last_page"
            :total-visible="10"
            circle
          />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="show = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Comment from '@/models/Comment'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    comment: {
      type: Comment
    }
  },
  data() {
    return {
      show: this.value,
      reports: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },
  mounted() {
    this.getReports()
  },
  methods: {
    getReports() {
      if (this.comment) {
        return this.comment
          .reports()
          .limit(10)
          .page(parseInt(this.reports.meta.current_page))
          .get()
          .then(reports => {
            this.reports = reports
          })
      }
    },

    onPageChanged(page) {
      this.reports.meta.current_page = page
      this.getReports()
    }
  },
  watch: {
    value(val) {
      this.show = val
    },

    comment(comment) {
      this.reports.meta.current_page = 1
      this.getReports()
    },

    show(val) {
      this.$emit('input', val)
      this.imgSrc = null
    }
  }
}
</script>
